(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchovy-carousel"] && !Shopify.designMode) return;
  try {
    
  const initAnchovyCarousel = (section) => {
    if (section.dataset.carouselInitialized === 'true') return;
    section.dataset.carouselInitialized = 'true';

    const track = section.querySelector('[data-carousel-track]');
    if (!track) return;
    const isTopics = section.classList.contains('anchovy-carousel--topics');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const move = (direction) => {
      const firstItem = track.querySelector('.anchovy-carousel__item');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = firstItem ? firstItem.getBoundingClientRect().width + gap : track.clientWidth * 0.72;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    section.querySelector('[data-carousel-prev]')?.addEventListener('click', () => move(-1));
    section.querySelector('[data-carousel-next]')?.addEventListener('click', () => move(1));

    if (!isTopics) {
      let isDragging = false;
      let didDrag = false;
      let startX = 0;
      let startScrollLeft = 0;

      const stopDragging = (event) => {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        isDragging = true;
        didDrag = false;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 4) didDrag = true;
        track.scrollLeft = startScrollLeft - distance;
      });
      track.addEventListener('pointerup', stopDragging);
      track.addEventListener('pointercancel', stopDragging);
      track.addEventListener('dragstart', (event) => event.preventDefault());
      track.addEventListener('click', (event) => {
        if (!didDrag) return;
        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      }, true);
      return;
    }

    const originalItems = Array.from(track.children);
    if (originalItems.length < 2) return;
    const dots = Array.from(section.querySelectorAll('[data-carousel-dot]'));
    const firstClone = originalItems[0].cloneNode(true);
    const lastClone = originalItems[originalItems.length - 1].cloneNode(true);

    [firstClone, lastClone].forEach((clone) => {
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => element.setAttribute('tabindex', '-1'));
    });

    track.insertBefore(lastClone, originalItems[0]);
    track.appendChild(firstClone);

    const allItems = Array.from(track.children);
    let activePosition = 1;
    let timer;
    let scrollTimer;
    let animationFrame;

    const itemCenter = (item) => item.offsetLeft + item.offsetWidth / 2;
    const trackCenter = () => track.scrollLeft + track.clientWidth / 2;
    const scrollToPosition = (position, behavior = 'smooth') => {
      const item = allItems[position];
      if (!item) return;
      track.scrollTo({ left: itemCenter(item) - track.clientWidth / 2, behavior });
    };

    const updatePresentation = () => {
      animationFrame = null;
      const center = trackCenter();
      let nearestPosition = 0;
      let nearestDistance = Infinity;

      allItems.forEach((item, position) => {
        const distance = Math.abs(itemCenter(item) - center);
        const progress = Math.max(0, 1 - distance / (item.offsetWidth * 0.9));
        const scale = 0.72 + progress * 0.28;
        item.style.setProperty('--carousel-scale', scale.toFixed(3));
        item.style.setProperty('--carousel-opacity', (0.78 + progress * 0.22).toFixed(3));
        if (section.classList.contains('anchovy-carousel--topics-primary')) {
          const direction = Math.sign(center - itemCenter(item));
          const shift = direction * item.offsetWidth * (1 - scale) / 2;
          item.style.setProperty('--carousel-shift', `${shift.toFixed(2)}px`);
        }
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestPosition = position;
        }
      });

      activePosition = nearestPosition;
      const originalIndex = Number(allItems[nearestPosition].dataset.carouselIndex);
      dots.forEach((dot, index) => {
        const active = index === originalIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const settleLoop = () => {
      if (activePosition === 0) {
        activePosition = originalItems.length;
        scrollToPosition(activePosition, 'auto');
      } else if (activePosition === allItems.length - 1) {
        activePosition = 1;
        scrollToPosition(activePosition, 'auto');
      }
      updatePresentation();
    };

    track.addEventListener('scroll', () => {
      if (!animationFrame) animationFrame = window.requestAnimationFrame(updatePresentation);
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(settleLoop, 140);
    }, { passive: true });

    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      activePosition = index + 1;
      scrollToPosition(activePosition);
    }));

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!section.hasAttribute('data-carousel-autoplay') || reducedMotion) return;
      timer = window.setInterval(() => {
        activePosition += 1;
        scrollToPosition(activePosition);
      }, 3800);
    };

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

    window.requestAnimationFrame(() => {
      scrollToPosition(1, 'auto');
      updatePresentation();
      start();
    });
  };

  document.querySelectorAll('.anchovy-carousel').forEach(initAnchovyCarousel);
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-review-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.reviewOpen);
      if (dialog) dialog.showModal();
      return;
    }
    const closeButton = event.target.closest('[data-review-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement) event.target.close();
  });
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.anchovy-carousel');
    if (section) initAnchovyCarousel(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
